import React from 'react';

import { useResponsiveFlags } from '../../../shared/lib';
import { SimpleButton } from './simpleButton';

export const SchemaControl = ({
  icon,
  onClick,
  title,
  isActive = false,
  disabled = false,
}: {
  icon: React.ReactNode;
  onClick: () => void;
  title?: string;
  isActive?: boolean;
  disabled?: boolean;
}) => {
  const { isMobile, isMediumScreen } = useResponsiveFlags();
  // Для средних экранов (600-900px) делаем кнопки размером как ArrowButton (40x40px)
  const buttonSize = isMediumScreen ? 40 : isMobile ? 44 : undefined;
  const buttonPadding = isMediumScreen ? 8 : isMobile ? 10 : 4;

  return (
    <SimpleButton
      onClick={onClick}
      label={icon}
      style={{
        border: null,
        padding: buttonPadding,
        minWidth: buttonSize,
        minHeight: buttonSize,
        width: buttonSize,
        height: buttonSize,
        backgroundColor: isActive ? 'black' : 'white',
        color: isActive ? 'white' : 'black',
        borderRadius: 8,
      }}
      title={title}
      disabled={disabled}
    />
  );
};
